import * as React from 'react'

function SvgWheelWrenchUnchecked(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path d="m29 12.414-2.293 2.293-1.414-1.414L27.586 11l-2.293-2.293 1.414-1.414L29 9.586l2.293-2.293 1.414 1.414L30.414 11l2.293 2.293-1.414 1.414L29 12.414Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 11c.347.008.686.076 1.002.198a8.963 8.963 0 0 0 2.149 5.64c-.088.319-.151.706-.151 1.162 0 1.118.223 1.688.368 1.942.016.027.031.052.046.074.088-.01.177-.016.268-.016.728 0 1.318.59 1.318 1.318V27h4v-6.84c0-.073-.002-.144-.006-.215a9.098 9.098 0 0 0 2.002 0c.003.071.004.143.004.214V29h-8v-6.197l-.574.861A3 3 0 0 1 19 24.999h-6v-.916c0 .917-.002.917-.003.917h-.022a1.071 1.071 0 0 1-.097-.006 1.959 1.959 0 0 1-.638-.193c-.354-.178-.733-.488-1.072-.996C10.508 22.814 10 21.079 10 18c0-3.08.508-4.814 1.168-5.805.339-.508.718-.818 1.072-.996a1.958 1.958 0 0 1 .638-.193 1.225 1.225 0 0 1 .097-.006h.022c.002 0 .003 0 .003 1v-1h6Zm-5.886 2h3.632a7.567 7.567 0 0 0-.328 1H12.5c.113-.318.23-.541.332-.695.131-.197.237-.277.282-.305Zm-1.021 3c-.058.56-.093 1.221-.093 2 0 .779.035 1.44.093 2h3.993A21.654 21.654 0 0 1 16 18c0-.737.03-1.401.086-2h-3.993Zm.739 6.695A3.169 3.169 0 0 1 12.5 22h3.918c.096.374.207.706.328 1h-3.632c-.045-.028-.15-.108-.282-.305Zm6.93-.14a1 1 0 0 1-.69.435c-.066-.05-.223-.197-.415-.61C18.326 21.663 18 20.325 18 18c0-2.325.326-3.663.657-4.38.192-.413.35-.561.415-.61a1 1 0 0 1 .69.435l.385.578c.205.308.446.586.714.829-.082.128-.17.279-.255.451C20.294 15.925 20 16.828 20 18c0 1.383.277 2.313.632 2.934.033.058.066.113.1.165l-.97 1.456Z"
      />
    </svg>
  )
}

export default SvgWheelWrenchUnchecked
